export function telHref(phone) {
  return `tel:${phone.replace(/[^0-9]/g, "")}`;
}

export function waHref(phone, text = "") {
  const digits = phone.replace(/[^0-9]/g, "").replace(/^0/, "");
  const base = `https://wa.me/972${digits}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
}
